<template>
    <div>
        <h2>① Animation</h2>
        <div class="row">
            <div class="col">
                <SelectLanguage/>
                <CharacterMooDeng desc pose="break" />
                <CharacterMooDeng desc pose="charge" />
                <CharacterMooDeng desc pose="float" />
                <CharacterMooDeng desc />
                <CharacterMooDeng desc pose="run" />
            </div>
            <div class="col">
                <strong>Hover to ...</strong>
                <CharacterMooDeng desc pose="dash" />
                <CharacterMooDeng desc pose="flinch" />
                <CharacterMooDeng desc pose="crouch" />
                <CharacterMooDeng desc pose="turn" />
                <CharacterMooDeng desc pose="jump" />
            </div>
        </div>
    </div>
</template>